var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"items":_vm.currencies,"label":_vm.$t('settings.currency.title'),"item-text":(item) => `${item.code} ${item.rate} ${item.symbol}`,"item-value":"id","return-object":""},on:{"change":_vm.itemChange},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }